import { createOpenAI } from "@ai-sdk/openai";
// import { createVertex } from "@ai-sdk/google-vertex/edge";
import { generateText } from "ai";
// Explicityly export instead of *
export { tool } from "ai";
export { z } from "zod";

const MODEL_IN_USE = "llama3.2";

const openai = createOpenAI({
  apiKey: "",
  compatibility: "strict",
});
const ollama = createOpenAI({
  apiKey: "ollama",
  baseURL: "http://localhost:11434/v1",
});
// const vertex = createVertex({});
const models = {
  "llama3.2": ollama("llama3.2"),
  "llama3.1": ollama("llama3.1"),
  // "gemini-1.5-flash": vertex("gemini-1.5-flash"),
  "gpt-4o": openai("gpt-4o"),
  "gpt-4o-mini": openai("gpt-4o-mini"),
};

export function runAgent({
  model = models[MODEL_IN_USE],
  system,
  messages,
  tools,
  maxSteps = 10,
  onStepFinish,
}: Partial<Parameters<typeof generateText>[0]>) {
  const stream = generateText({
    model,
    system,
    messages,
    tools,
    maxSteps,
    onStepFinish,
  });
  return stream;
}
